// extracted by mini-css-extract-plugin
export default {"product_container":"ProductItem_product_container__X7elF"};